import * as React from 'react';

interface Props {
  height?: string;
  width?: string;
  color?: string;
  title?: string;
  styles?: any;
  handleClick?: () => void;
}

const ArrowDropUp = ({ height, width, color, title, styles, handleClick }: Props) => {
  return (
    <div
      title={title || ''}
      style={{ position: 'absolute', width: 18, height: 10, bottom: 4, zIndex: 999, overflow: 'hidden' }}
      onClick={event => {
        event.stopPropagation();
        handleClick();
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || '24'}
        height={height || '24'}
        viewBox="0 0 24 24"
        style={styles || {}}
      >
        <path d="M7 14l5-5 5 5z" fill={color || 'none'} />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </div>
  );
};

export default ArrowDropUp;
